function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1254 -31)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "none",
  stroke: "#fff",
  transform: "translate(1254.5 31.5)"
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(1261 48)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fontFamily: "Helvetica,Helvetica Neue",
  fontSize: 14,
  fontWeight: 500
}, "?")));

function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23"
  }, props), _ref);
}

export default SvgIconInfo;